import React from 'react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-103" data-mp="1o3ncvzyfwkwu">
      <Reveal className="mx-auto max-w-2xl rounded-2xl border border-amber/50 bg-mist p-9 text-center shadow-premium sm:p-12" data-id="element-104" data-mp="1o3dmwcdeadr5">
        <div className="text-5xl" aria-hidden="true" data-id="element-105" data-mp="1x4bsv07e8vcd">
          🛡️
        </div>
        <h2 className="mt-5 font-serif text-4xl leading-tight text-navy sm:text-5xl" data-id="element-106" data-mp="1x28qrhsyvbra">
          Zero Risk. 7-Day Money-Back Guarantee.
        </h2>
        <p className="mt-6 text-sm leading-7 text-slate sm:text-base" data-id="element-107" data-mp="14gfmf3s0vp2e">
          Download all 6 volumes, explore the 5 bonus guides, and access the complete printable
          resource library. If within 7 days you decide the system is not right for you, contact us
          for a refund according to our guarantee policy.
        </p>
        <p className="mt-7 font-semibold text-sage" data-id="element-108" data-mp="qmew8yf4zadn">✅ Real refund rate: less than 1%</p>
      </Reveal>
    </section>;
}